module.exports = __webpack_public_path__ + "img/electron-icon.2a6810bd.svg";